<template>
	<div class="upload-recharge-img">
		<el-upload class="avatar-uploader" :action="$props.ossObj.host||'#'" :data="ossParpmsData"
			:show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
			<div v-if="imageUrl" class="image-box">
				<img :src="imageUrl" class="avatar" :style="{...UpStyle,lineHeight:UpStyle.height}">
				<i v-if="isClose" class="el-icon el-icon-close" @click.stop.prevent="removeImg"></i>
			</div>
			<i v-else class="el-icon-plus avatar-uploader-icon" :style="{...UpStyle,lineHeight:UpStyle.height}"></i>
		</el-upload>
	</div>
</template>

<script>
	import {
		S4
	} from '@/utils/utils.js'
	export default {
		props: {
			ossData: Object,
			ossObj: Object,
			isClose:{
				type:Boolean,
				default:true
			},
			imgUrl:{
				type:String,
				default:''
			},
			UpStyle:{
				type:Object,
				default:()=>{
					return {
						height:'80px'
					}
				}
			},
		},
		data() {
			return {
				imageUrl: '',
				ossParpmsData: {},
			};
		},
		methods: {
			removeImg() {
				this.imageUrl = ''
				this.$emit('handleRemove')
			},
			handleAvatarSuccess() {
				console.log(this.ossParpmsData,1111122)
				this.imageUrl = this.$props.ossObj.host + "/" + this.ossParpmsData.key
				
				this.$emit('handleSuccess', this.imageUrl)
			},
			beforeAvatarUpload(file) {
				let typeName=file.type.split("/")[1]||''
				const isImg = file.type.indexOf('image/') > -1;
				if (!isImg) {
					this.$message.error('上传图片格式不正确');
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				const time = new Date().getTime() + Math.random() * 1000
				let key = `${this.$props.ossObj.dir}${time}_${S4()}.${typeName}`
				this.ossParpmsData.key = key
				return isImg && isLt2M;

			}
		},
		mounted() {
			this.imageUrl=this.imgUrl
			this.ossParpmsData = JSON.parse(JSON.stringify(this.ossData))
		}
	}
</script>

<style scoped lang="scss">
	.image-box {
		position: relative;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		overflow: hidden;
	}

	.image-box .el-icon-close {
		position: absolute;
		right: 0;
		top: 0;
		border-radius: 50%;
		color: white;
		background: #f56c6c;
	}

	/deep/ .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}



	/deep/ .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}
	
</style>
